import { useQuery } from '@tanstack/react-query';
import { useSetRecoilState } from 'recoil';

import { axiosInstance } from '../../../axios/axiosInstance';
import { userData } from '../../../recoil/atoms/userDataAtom';
import { urls } from '../../../services/auth-service/auth.service';
import { setUserLocalData } from '../../../services/user-service/user.service';

export const key = ['USER_DATA'];
export const useGetUserData = () => {
  const setUserData = useSetRecoilState(userData);
  return useQuery(
    key,
    async () => {
      const { data } = await axiosInstance.get(urls.me);
      return data;
    },
    {
      onSuccess: (data) => {
        setUserLocalData(data);
        setUserData(data);
      },
    },
  );
};
